import React, { Component } from 'react';

import { ResponsivePie } from '@nivo/pie';
import { utils } from '../../../../core/helpers/utils';

class PieChartsWithLegends extends Component {
  constructor(props) {
    super(props);

    this.tooltipFormat = this.tooltipFormat.bind(this);
    this.tooltip = this.tooltip.bind(this);
  }
  
  tooltipFormat(d) {
    return this.props.tooltipFormat(d);
  }

  tooltip(d) {
    return this.props.tooltip(d);
  }

  render() {
    var height = this.props.height;
    var defaultMargins = { "top": 40, "right": 0, "bottom": 140, "left": 0 };
    var defaultLegends = [{ "anchor": "bottom",
                            "direction": "column",
                            "translateY": 140,
                            "itemWidth": 500,
                            "itemHeight": 20,
                            "symbolSize": 14,
                            "symbolShape": "circle",
                            legendFormat: (d)=> `${d}helloworld`
                          }];

    return (
      <div style={{width: 100 + '%', height: this.props.height + 'px'}}>
        <ResponsivePie
              data={this.props.data}
              margin={this.props.margins ? this.props.margins : defaultMargins}
              padAngle={0.7}
              cornerRadius={3}
              colors={this.props.colors ? this.props.colors : utils.getCharColors()}
              colorBy="id"
              borderColor="inherit:darker(0.6)"
              enableRadialLabels={this.props.enableRadialLabels ? this.props.enableRadialLabels : false}
              enableSlicesLabels={this.props.enableSlicesLabels ? this.props.enableSlicesLabels : false}
              radialLabelsSkipAngle={this.props.radialLabelsSkipAngle ? this.props.radialLabelsSkipAngle : 10}
              slicesLabelsSkipAngle={10}
              slicesLabelsTextColor="#ffffff"
              animate={true}
              motionStiffness={90}
              motionDamping={15}
              slicesLabelsTextColor={this.props.slicesLabelsTextColor ? this.props.slicesLabelsTextColor : '#fff'}
              sortByValue={this.props.sortByValue ? this.props.sortByValue : false}
              innerRadius={this.props.innerRadius ? this.props.innerRadius : 0}
              legends={this.props.legends ? this.props.legends : defaultLegends}
              tooltipFormat={typeof(this.props.tooltipFormat) === "function" ? (d) => this.tooltipFormat(d) : undefined}
              tooltip={typeof(this.props.tooltip) === "function" ? (d) => this.tooltip(d) : undefined}
            />
      </div>
    );
  }
}

export default PieChartsWithLegends;
